export const API = `${process.env.REACT_APP_BACKEND_URL}/api/nba`;
export const STATUS_CLS = {
  APPROVED: "bg-emerald-600 text-white", CORE: "bg-orange-500 text-slate-950", VALUE: "bg-amber-400/90 text-slate-950",
  WATCH: "bg-sky-900/80 text-sky-200", PASS: "bg-slate-800 text-slate-400", PROJECTED: "bg-violet-950/80 text-violet-200 ring-1 ring-violet-500/50",
  "DATA BLOCKED": "bg-rose-950/70 text-rose-300",
};
export const LINEUP_CLS = {
  CONFIRMED: "border-emerald-500/60 bg-emerald-950/40 text-emerald-300",
  EXPECTED: "border-amber-500/50 bg-amber-950/30 text-amber-300",
  PROJECTED: "border-dashed border-violet-500/60 bg-violet-950/30 text-violet-300",
};
export const na = (v, suf = "") => (v === null || v === undefined ? "N/A" : `${v}${suf}`);
export const pct = (v, d = 1) => (v === null || v === undefined ? "N/A" : `${(v * 100).toFixed(d)}%`);
export const time = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : "");
export const fmtDay = (d) => d.toLocaleDateString("en-CA", { timeZone: "America/New_York" });
export const slug = (s) => String(s || "").replace(/\W+/g, "-").toLowerCase();

export const StatusPill = ({ s, testId }) => (
  <span data-testid={testId} className={`inline-block whitespace-nowrap rounded px-1.5 py-0.5 font-mono text-[9px] font-bold ${STATUS_CLS[s] || "bg-slate-800 text-slate-400"}`}>{s}</span>
);

export const LineupPill = ({ s }) => (
  <span className={`inline-block rounded border px-1.5 py-0.5 font-mono text-[9px] font-bold ${LINEUP_CLS[s] || "border-slate-700 text-slate-500"}`}>{s || "NO LINEUP"}</span>
);
